import { useState } from 'react';
import { useMutation } from 'react-query';

import { BUTTON_TYPES } from '@savgroup-front-common/constants/shared';
import { CommonRepairerService } from '@savgroup-front-common/core/api/Repairer';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { Heading } from '@savgroup-front-common/core/atoms/Heading';
import { Signature } from '@savgroup-front-common/core/atoms/Signature';
import { toast } from '@savgroup-front-common/core/atoms/Toast';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';

import messages from './messages';
import { $SignatureRequiredContainer } from './SignatureRequired.styles';

export const SignatureRequired = ({
  interventionId,
  onSubmit,
}: {
  onSubmit: () => void;
  interventionId?: string;
}) => {
  const [signature, setSignature] = useState<Base64URLString | undefined>(
    undefined,
  );

  const {
    mutateAsync: handleSignServiceReport,
    isLoading: isSignServiceReportLoading,
  } = useMutation(['handleSignServiceReport'], async () => {
    if (!signature || !interventionId) {
      return undefined;
    }
    const response =
      await CommonRepairerService.uploadInterventionReportSignatureCommand({
        interventionId,
        signature,
      });

    if (response.failure) {
      toast.error(messages.signServiceReportError);

      return undefined;
    }

    toast.success(messages.signServiceReportSuccess);
    onSubmit();

    return undefined;
  });

  return (
    <$SignatureRequiredContainer>
      <Heading level={5}>
        <SafeFormattedMessageWithoutSpread
          message={messages.signServiceReportTitle}
        />
      </Heading>

      <Signature onUpdateSignature={(signature) => setSignature(signature)} />

      <Button
        type={BUTTON_TYPES.BUTTON}
        onClick={() => handleSignServiceReport()}
        disabled={!signature}
        isLoading={isSignServiceReportLoading}
        primary
      >
        <SafeFormattedMessageWithoutSpread
          message={messages.signServiceReportConfirmButton}
        />
      </Button>
    </$SignatureRequiredContainer>
  );
};
